import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
export default {
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  emptyMessage: " No App References Found",
  fields: [
    {
      attributeName: 'appName',
      label: 'App Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of composed experience',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'appConfigName',
      label: 'App Config Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Type of composed experience',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'appContentName',
      label: 'App Content Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the App Content',
      canOrder: false,      
      canFilter: false,
    },
    {
      attributeName: 'isSportRoom',
      label: 'Is Space?',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Indicates if content is a Space',
      canEdit: true,
      disabled: true,
      canOrder: false,      
      canFilter: false,
      default: true,
    },
    {
      attributeName: 'contentLink',
      label: 'Link to Content',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      helpText: 'Link to the app / room edit form',
      canOrder: false,      
      canFilter: false,
    },
  ],
};
